/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { experienceSchema } from './experience-schema';

export const experiencesFocusAreaOrderPreferenceSchema: z.AnyZodObject = z.object({
  createdAt: z.string().datetime().nullish(),
  experience: z.lazy(() => experienceSchema).nullish(),
  experienceId: z.string().uuid().nullish(),
  focusAreas: z.array(z.string()).nullish(),
  id: z.string().uuid(),
  updatedAt: z.string().datetime().nullish(),
});

export type ExperiencesFocusAreaOrderPreference = z.infer<typeof experiencesFocusAreaOrderPreferenceSchema>;
